import { render, staticRenderFns } from "./CanShareRecord.vue?vue&type=template&id=2de779ed&scoped=true"
import script from "./CanShareRecord.vue?vue&type=script&lang=js"
export * from "./CanShareRecord.vue?vue&type=script&lang=js"
import style0 from "./CanShareRecord.vue?vue&type=style&index=0&id=2de779ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de779ed",
  null
  
)

export default component.exports